import React, { useEffect } from 'react';
import { FormGroup, InputGroup, FormControl, HelpBlock } from 'react-bootstrap';
import _ from 'lodash';

import FormLabel from '../FormLabel/FormLabel';

export default function InputCollection(props) {
    const errorMessages = Array.isArray(props.errorMessage)
        ? props.errorMessage.filter((message) => !_.isEmpty(message))
        : !_.isEmpty(props.errorMessage)
            ? [props.errorMessage]
            : [];

    let hasError = errorMessages.length > 0;
    const labelHasError = _.isUndefined(props.labelHasError) ? hasError : props.labelHasError;
    const helpBlockClassName = props.helpBlockClassName || '';

    const labelProps = {
        required: props.required,
        helpText: props.helpText,
        hasError: labelHasError
    };

    const groupProps = {
        validationState: hasError ? 'error' : null
    };

    let inputControl = props.children;
    let justifyContent = props.justifyContent ? props.justifyContent : 'space-between';

    if (props.prefix || props.postfix) {
        inputControl = (
            <InputGroup>
                {
                    props.prefix && <InputGroup.Addon>{props.prefix}</InputGroup.Addon>
                }
                {inputControl}
                {
                    props.postfix && <InputGroup.Addon>{props.postfix}</InputGroup.Addon>
                }
            </InputGroup>
        );
    }

    useEffect(() => {
        const optionListContainer = document.getElementsByClassName('optionListContainer')[0];
        if (optionListContainer) {
            optionListContainer.onmousedown = function (e) {
                e.preventDefault();
            };
        }
    });

    return (
        <FormGroup {...groupProps}>
            {
                <div style={{ display: "flex", justifyContent: justifyContent, flexFlow: "row", width: "100%" }}>
                    {
                        props.labelText && <FormLabel {...labelProps}>{props.labelText}</FormLabel>
                    }
                    {
                        props.showInfo && <span>{props.infoText}</span>
                    }
                </div>
            }
            <div style={{position: "relative"}}>
                {inputControl}
                {
                    hasError && <FormControl.Feedback />
                }
                {
                    hasError && (
                        <HelpBlock className={helpBlockClassName}>
                            <i className="fa fa-exclamation-circle"></i>&nbsp;
                            {errorMessages.map((message, index) => (
                                <span key={`${index}-${message}`}>{message}</span>
                            ))}
                        </HelpBlock>
                    )
                }
            </div>
        </FormGroup>
    );
}